import { gql } from '@apollo/client';

export const GET_DELIVERY_TASK_DETAIL = gql`
  query GetDeliveryTaskDetail($id: Long!) {
    getDeliveryTaskDetail(taskId: $id) {
      id
      routeHistoryId
      routeName
      originalDriverId
      driverAccountId
      pathPlanningTaskId
      areaId
      areaName
      warehouseId
      dspId
      taskDate
      status
      assignedParcels
      actualPickedUpParcels
      transferInParcels
      transferOutParcels
      actualTotalParcels
      estimatedDistanceKm
      estimatedDurationMinutes
      createdBy
      createdAt
      updatedAt
      originalDriverName
      actualDriverName
      taskHistory {
        id
        eventType
        dataJson
        createdAt
        description
      }
      parcels {
        id
        trackingNo
        zipcode
        pickupStatus
        stop
        subStopNumber
        status
      }
    }
  }
`;